// removed by extract-text-webpack-plugin
module.exports = {"Login":"_1tjKSieZotgd93VTyj3j6P","Logo":"_1cc9klfGEK5YGuTzFCe5Vp","loginForm":"_3VfbnTdEbCtaLd7g2YsoiZ","textField":"_1Y0sw0fJft-xLR4hZJZVtx","loginBtn":"_3jNc1lBXCXM-5Yx6siY29j"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/Login.css
// module id = 924
// module chunks = 0